DecimalInstanceError.prototype = Object.create(TypeError.prototype);
DecimalInstanceError.prototype.constructor = DecimalInstanceError;

DecimalNumberError.prototype = Object.create(TypeError.prototype);
DecimalNumberError.prototype.constructor = DecimalNumberError;

const INVALID_DECIMAL_INSTANCE_ERROR = 'Expected instance of "Decimal"';
const INVALID_DECIMAL_NUMBER_ERROR = 'Expected "Decimal" value to be a valid "number" or "String(number)"';

export function DecimalInstanceError(this: $TSFixMe) {
    this.message = INVALID_DECIMAL_INSTANCE_ERROR;
    this.stack = new TypeError().stack;
}

export function DecimalNumberError(this: $TSFixMe) {
    this.message = INVALID_DECIMAL_NUMBER_ERROR;
    this.stack = new TypeError().stack;
}
